import req from './../../../../../../fetch';
import { undocumentedResponse } from './../../../../../../utils';
import {
  ClaimsPostResponseType,
  NetworkType,
  AllAPIResponses,
  CarbonError,
} from './../../../../../../index';

type Params = {
  networkType: NetworkType;
  id: number;
};

// The payload the user submits for queueing a Temperature Reporting Settings.
// reportLevels length should be 1 less than reportIntervals.
// At least one reportLevels and two reportIntervals should always be present.
//  Reporting intervals must be evenly divisible by the temperature check interval.
type Payload = {
  reportIntervals: number[];
  reportLevels: number[];
};

const post = async (
  params: Params,
  payload: Payload,
  headers?: Headers
): Promise<AllAPIResponses<ClaimsPostResponseType>> => {
  try {
    const resp = await req.post(
      `/api/claims/${params.networkType}/${params.id}/settings/tempreportconfig`,
      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 201:
        return {
          data: (await resp.json()) as ClaimsPostResponseType,
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default post;
